module.exports = __webpack_public_path__ + "img/loans.7243b16.svg";